import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CalendarDays, ClipboardCheck, Users, CalendarRange, Thermometer } from 'lucide-react';
import { useAuth } from '../App';
import MyTimeOff from './timeOff/MyTimeOff';
import RequestsQueue from './timeOff/RequestsQueue';
import Balances from './timeOff/Balances';
import YearCalendar from './timeOff/YearCalendar';
import WhosOff from './timeOff/WhosOff';

export const TO_API = `${process.env.REACT_APP_BACKEND_URL}/api/time-off`;
export const KIND_COLORS = {
  vacation: 'bg-emerald-500 text-white', pending: 'bg-amber-300 text-amber-900', sick: 'bg-rose-500 text-white',
  absent: 'bg-slate-500 text-slate-900', stat: 'bg-indigo-200 text-indigo-900',
};
export const KIND_LABELS = { vacation: 'Vacation', pending: 'Pending approval', sick: 'Sick', absent: 'Absent', stat: 'Stat holiday' };
export const fmtDay = (d) => new Date(`${d}T12:00:00`).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

export default function TimeOff() {
  const { user } = useAuth();
  const [me, setMe] = useState(null);
  const [tab, setTab] = useState('mine');
  const [pending, setPending] = useState(0);

  const loadMe = async () => {
    try { const r = await axios.get(`${TO_API}/me`); setMe(r.data); } catch { /* ignore */ }
  };
  const loadPending = async (isHr, isMgr) => {
    if (!isHr && !isMgr) return;
    try { const r = await axios.get(`${TO_API}/requests`, { params: { status: 'submitted,hr_reviewed' } }); setPending((r.data.requests || []).length); } catch { /* ignore */ }
  };
  useEffect(() => { loadMe(); }, []);
  useEffect(() => { if (me) loadPending(me.is_hr, me.is_manager); }, [me]);

  if (!me) return <div className="p-6 text-slate-500">Loading…</div>;
  const tabs = [
    { id: 'mine', label: 'My Time Off', icon: CalendarDays },
    ...(me.is_hr || me.is_manager ? [{ id: 'requests', label: 'Requests', icon: ClipboardCheck, badge: pending }] : []),
    ...(me.is_hr || me.is_manager ? [{ id: 'balances', label: 'Balances & Sick Days', icon: Users }] : []),
    { id: 'calendar', label: 'Year Calendar', icon: CalendarRange },
    { id: 'whosoff', label: "Who's Off", icon: Thermometer },
  ];
  return (
    <div className="p-4 md:p-6 space-y-4" data-testid="time-off-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Time Off</h1>
        <p className="text-blue-800 text-sm">Vacation requests, approvals, sick days and the year at a glance</p>
      </div>
      <div className="flex gap-1 flex-wrap bg-white rounded-xl p-1">
        {tabs.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} data-testid={`time-off-tab-${t.id}`}
            className={`px-3 py-2 rounded-lg text-sm font-medium flex items-center gap-1.5 ${tab === t.id ? 'bg-blue-600 text-white' : 'text-slate-800 hover:bg-slate-900/5'}`}>
            <t.icon className="w-4 h-4" /> {t.label}
            {t.badge > 0 && <span className="ml-1 bg-red-500 text-white text-xs font-bold rounded-full px-1.5" data-testid="time-off-pending-badge">{t.badge}</span>}
          </button>
        ))}
      </div>
      {tab === 'mine' && <MyTimeOff me={me} user={user} onChanged={loadMe} />}
      {tab === 'requests' && <RequestsQueue me={me} user={user} onChanged={() => { loadMe(); }} />}
      {tab === 'balances' && <Balances me={me} />}
      {tab === 'calendar' && <YearCalendar me={me} user={user} />}
      {tab === 'whosoff' && <WhosOff />}
    </div>
  );
}
